import React, { useState, useEffect } from 'react';
import { ArrowUp } from 'lucide-react';
import i18n from '../../i18n/config';

const FloatingActionButton: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setIsVisible(scrollPosition > 300); // Show button after scrolling 300px
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToForm = () => {
    const formSection = document.querySelector(`#${i18n.t('anchor_links.loan_application_form')}`);
    if (formSection) {
      formSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  if (!isVisible) return null;

  return (
    <button
      onClick={scrollToForm}
      className="fixed bottom-8 right-8 bg-[#f1c40f] hover:bg-[#1abc9c] text-[#2c3e50] rounded-full p-4 shadow-lg hover:shadow-xl transition-all duration-300 flex items-center gap-2 group"
      aria-label={i18n.t('floating_button.aria_label')}
    >
      <span className="hidden md:inline-block">{i18n.t('floating_button.text')}</span>
      <ArrowUp className="w-6 h-6 group-hover:-translate-y-1 transition-transform duration-300" />
    </button>
  );
};

export default FloatingActionButton; 